import React, { useState, useEffect } from "react";
// import tw from "twin.macro";
import moment from "moment";
// import Skeleton from "react-loading-skeleton";
import { Link, useNavigate } from "react-router-dom";
import { ECommerce } from "api/AppConfigApi";
import toast, { Toaster } from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import { getProduct } from "api/ProductApi";
import RemoveCart from "components/RemoveCart";
import { filterFormatToDate } from "utility/Constant";
import { getCustomerId } from "utility/HeaderConfig";
import { useCartContext } from "context/UseCartContext";
import { getAddToCart, getBranchId } from "utility/HeaderConfig";
import Noimg from "../images/no_img.jpg";

// const StyledDiv = tw.div`font-display overflow-hidden`;

export default ({ configImages }) => {
  const [verifyAmount,setVerifyAmount] =useState(0);
  const [validation, setValidation] = useState(true);
  const [viewCart, setViewCart] = useState([]);   // eslint-disable-next-line
  const [total, setTotal] = useState([]);
  const [showModal, setShowModal] = useState("");          // eslint-disable-next-line
  const [banner, setBanner] = useState([]);
  // const [pincode, setPincode] = useState("");
  // const [showPincodeInput, setShowPincodeInput] = useState(false);
  const history = useNavigate();
  // const prms = history.location.state
  // console.log("prms",prms);
  const { dispatch, data } = useCartContext();

  useEffect(() => {
    if (history?.location?.state) {
      // setViewCart(history?.location?.state?.propValueData)
    } else {
      viewCartList();
      getBanner();
    }
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (history?.location?.state) {
      setViewCart(history?.location?.state?.propValueData);
      calcTotal(history?.location?.state?.propValueData);
    } else {
      viewCartList();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getBanner();
    getPriceCheck();
    // viewCartList();
    //eslint-disable-next-line
  }, []);

  const calcTotal = (cartList) => {
    setValidation(true);
    let totalCartValue = 0;
    cartList &&
      cartList.forEach((data) => {
        if (data.total > 0) {
          totalCartValue += data.total;
        }
      });
    const isSoldProductAvailable =
      cartList.length > 0 &&
      cartList.some((data) => data.statusName?.toLowerCase() === "sold");
    if (isSoldProductAvailable) setValidation(false);
    setTotal(totalCartValue);
  };

  const getBanner = () => {
    configImages &&
      configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "cart") {
          setBanner(data.value);
        }
      });
  };

  const viewCartList = () => {
    let dataList = [];
    // let basePrice = 0;
    // let total = 0;
    // let cgst = 0;
    // let sgst = 0;
    const newArray =
      getAddToCart() &&
      JSON.parse(getAddToCart()).filter(
        (cartItem) => cartItem.branchId === getBranchId()
      );
    if (newArray?.length > 0) {
      newArray &&
        newArray.forEach((element, index) => {
          let filter = {
            branch: getBranchId(),
            id: element.id,
            beforeCreatedAt: filterFormatToDate(moment().format("YYYY-MM-DD")),
          };
          const respData = getProduct(10, filter);
          respData.then((res) => {
            dataList.push(res.response.content[0]);
            newArray &&
              newArray.forEach((element, index) => {
                if (dataList.length - 1 === index) {
                  // if (dataList[index].basePrice) {
                  //   basePrice += Number(dataList[index].basePrice);
                  // }
                  // if (dataList[index].total) {
                  //   total += Number(dataList[index].total);
                  // }
                  // if (dataList[index].saleTaxList[1].amount) {
                  //   cgst += Number(dataList[index].saleTaxList[1].amount);
                  // }
                  // if (dataList[index].saleTaxList[0].amount) {
                  //   sgst += Number(dataList[index].saleTaxList[0].amount);
                  // }
                  let totalAmount = 0;
                  if (dataList.length > 0) {
                    totalAmount = dataList.reduce((result, item) => {
                      return (result += parseFloat(Math.trunc(item.total)));
                    }, 0);
                  }
                  setTotal(totalAmount);
                  setViewCart(dataList);
                }
              });
          });
        });
    }
  };

  const removeItemFromCart = (code) => {
    let productData = JSON.parse(getAddToCart());
    const result = productData.filter((item) => item.productCode !== code);
    if (result) {
      reactLocalStorage.set("CartList", JSON.stringify(result));
      dispatch({ type: "ADD", payload: result});
      setViewCart(result);
      let dataList = [];
      // let basePrice = 0;
      // let total = 0;
      // let cgst = 0;
      // let sgst = 0;
      result &&
        result.forEach((element, index) => {
          dataList.push(element);
          // if (dataList[index].basePrice) {
          //   basePrice += Number(
          //     dataList[index].basePrice +
          //       dataList[index].gemTotal +
          //       dataList[index].diamondTotal
          //   );
          // }
          // if (dataList[index].total) {
          //   total += Number(dataList[index].total);
          // }
          // if (dataList[index].saleTaxList[1].amount) {
          //   cgst += Number(dataList[index].saleTaxList[1].amount);
          // }
          // if (dataList[index].saleTaxList[0].amount) {
          //   sgst += Number(dataList[index].saleTaxList[0].amount);
          // }
          let totalAmount = 0;
          if (dataList.length > 0) {
            totalAmount = dataList.reduce((result, item) => {
              return (result += parseFloat(Math.trunc(item.total)));
            }, 0);
            setTotal(totalAmount);
          }
          setViewCart(dataList);
        });
      // setViewCart(dataList);
      // setTotal([total, cgst, sgst, basePrice]);
      toast.success("Product Removed From the Cart !", {
        duration: 3000,
        position: "top-right",
      });
      setShowModal("");
      calcTotal(dataList);
    }
  };

const checkout = () => {
  const finalTotal = totalCharge;
  if (finalTotal <= verifyAmount) {  
    if (getCustomerId()) {
      history("/CheckoutPage", {
        state: {
          viewCart: viewCart,
          total: finalTotal
        }
      });
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  } else {
    toast.error(
      `The Purchase Amount Shouldn't Be Greater Than ${verifyAmount}`,
      {
        position: "top-right",
        duration: 3000
      }
    );
  }
};

  const getPriceCheck = async ()=>{
    
    let  filter = 'sales_threshold';
      let appConfigResData = await ECommerce(filter);
      let appConfigthresholdValue = JSON.parse(appConfigResData.response.moduleField);
      let saleThresholdValue = 0;
      Object.entries(appConfigthresholdValue).forEach((entry) => {
      if (entry[0] === "sales_threshold_amount") {
          saleThresholdValue = entry[1];
      }
  });
  setVerifyAmount(saleThresholdValue);
  }

  const getImageUrl = (list) => {
    if (list.images) {
      return list.images.split("@#@")[0];
    }
    return Noimg;
  };

 const subtotal = viewCart.reduce( (acc, item) => acc + (item.basePrice || 0), 0, );

  const taxAmount = viewCart.reduce((acc, item) => {
    const taxes = item.saleTaxList || [];
    const itemTax = taxes.reduce((t, tax) => t + (tax.amount || 0), 0);
    return acc + itemTax;
  }, 0);

  const otherCharges = viewCart.reduce((acc, item) => {
    return (
      acc +
      (item.diamondTotal || 0) +
      (item.gemTotal || 0) +
      (item.diamondTax || 0)
    );
  }, 0);

  const totalCharge = viewCart.reduce((acc, item) => acc + (item.total || 0), 0, );

  return (
    <>
      <Toaster position="top-right" />
      {/* {banner && banner.length > 0 ? (
        <img
          src={banner}
          alt="Jewellery Product Cart Items"
          className="w-100"
        />
      ) : (
        <Skeleton tw="w-full" style={{ height: "200px" }} />
      )}     */}
      <div
        style={{ maxWidth: "1200px", margin: "0 auto", padding: "24px 16px" }}
      >
        {viewCart.length > 0 ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 360px",
              gap: "20px",
              alignItems: "start",
            }}
          >
            {/* LEFT COLUMN */}
            <div>
              <div
                style={{
                  background: "linear-gradient(135deg, #d4f5e9 0%, #f8e8c2 100%)",
                  borderRadius: "12px",
                  padding: "16px 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                  border: "1px solid #9FE1CB",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      background: "#1D9E75",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                      <path d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4z" />
                    </svg>
                  </div>
                  <div>
                    <div style={{ fontSize: "14px", fontWeight: "600", color: "#085041", }}>
                      See it Before You Buy It
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#0F6E56",
                        marginTop: "2px",
                      }}
                    >
                      Experience our designs in detail via video call.
                    </div>
                  </div>
                </div>
                <Link to="/BookAnAppointment">
                  <button
                    style={{
                      background: "#1D9E75",
                      color: "white",
                      border: "none",
                      borderRadius: "13px",
                      padding: "8px 13px",
                      fontSize: "11px",
                      fontWeight: "600",
                      cursor: "pointer",
                      letterSpacing: "0.5px",
                    }}
                  >
                    BOOK NOW
                  </button>
                </Link>
              </div>

              {/* Cart Items */}
              {viewCart.map((list, idx) => (
                <div
                  key={idx}
                  style={{
                    background: "#fbf5ff9a",
                    borderRadius: "12px",
                    border: "1px solid #f4ecfa",
                    marginBottom: "16px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{ display: "flex", gap: "16px", padding: "16px" }}
                  >
                    {/* Product Image */}
                    <div style={{ position: "relative" }}>
                      <img
                        src={getImageUrl(list)}
                        alt={list.title}
                        style={{
                          width: "130px",
                          height: "130px",
                          objectFit: "contain",
                          background: "#f7eafd",
                          borderRadius: "8px",
                        }}
                      />
                    </div>

                    {/* Details */}
                    <div style={{ flex: 1 }}>
                      <div
                        style={{ display: "flex",  justifyContent: "space-between",  alignItems: "flex-start", }}
                      >
                        <div style={{ flex: 1 }}>
                          <div
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center",}}
                          >
                            <span
                              style={{
                                fontSize: "11px",
                                fontWeight: "400",
                                color: "#5e594e",
                                marginBottom: "6px",
                              }}
                            >
                              {list.title}
                            </span>
                            <span
                              style={{
                                fontSize: "8px",
                                color: "var(--ink-500)",
                              }}
                              className="mx-3 mt-2"
                            >
                              <span
                                style={{
                                  padding: "3px 9px",
                                  borderRadius: "var(--radius-pill)",
                                  background: "var(--ink-200)",
                                  border: `1px solid ${"var(--gold-200)"}`,
                                  fontSize: 10,
                                  letterSpacing: ".01em",
                                  color: "var(--ink-400)",
                                }}
                              >
                                {list.goldPurity}
                              </span>
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              marginBottom: "6px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "17px",
                                fontWeight: "700",
                                color: "#6b5330",
                              }}
                            >
                              ₹{Math.trunc(list.total).toLocaleString("en-IN")}
                            </span>
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#6b5330",
                              marginBottom: "5px",
                            }}
                          >
                            {list.skv}
                          </div>
                          <div style={{ fontSize: "10px", color: "#f5d384" }}>
                            {list.sectionName}
                          </div>
                          <div style={{ fontSize: "13px", color: "#f0bb41" }}>
                            Type: {list.metalType}
                          </div>
                      {list?.statusName?.toLowerCase() === "sold" && (
                        <div>
                          {" "}
                          <span style={{ color: "red" }}>
                            * This Item is Sold Please Remove this Item
                          </span>
                        </div>
                      )}
                        </div>
                        {/* Remove Button */}
                        <button
                          onClick={() => setShowModal(list.skv)}
                          style={{
                            background: "#6b5330",
                            borderRadius: "50%",
                            width: "18px",
                            height: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                          title="Remove"
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {/* Continue Shopping */}
              <button
                onClick={() => history("/productList")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  marginTop: 16,
                  padding: "12px 20px",
                  background: "#6b5330",
                  color: "#fff",
                  fontSize: 13,
                  fontWeight: 600,
                  letterSpacing: ".05em",
                  border: "none",
                  borderRadius: 9,
                  cursor: "pointer",
                  width: "30%",
                  transition: "background .14s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#9c7a3a")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "#6b5330")
                }
              >
                <svg
                  width="8%"
                  height="8%"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Continue Shopping
              </button>
            </div>

            {/* RIGHT COLUMN — Sidebar */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {/* Check Delivery */}
              {/* <div
                style={{
                  background: "white",
                  borderRadius: "12px",
                  border: "1px solid #e8e8e8",
                  padding: "14px 16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowPincodeInput(!showPincodeInput)}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "30px",
                        height: "30px",
                        justifyContent: "center",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <svg
                        width="50%"
                        height="50%"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.00014 14H18.1359C19.1487 14 19.6551 14 20.0582 13.8112C20.4134 13.6448 20.7118 13.3777 20.9163 13.0432C21.1485 12.6633 21.2044 12.16 21.3163 11.1534L21.9013 5.88835C21.9355 5.58088 21.9525 5.42715 21.9031 5.30816C21.8597 5.20366 21.7821 5.11697 21.683 5.06228C21.5702 5 21.4155 5 21.1062 5H4.50014M2 2H3.24844C3.51306 2 3.64537 2 3.74889 2.05032C3.84002 2.09463 3.91554 2.16557 3.96544 2.25376C4.02212 2.35394 4.03037 2.48599 4.04688 2.7501L4.95312 17.2499C4.96963 17.514 4.97788 17.6461 5.03456 17.7462C5.08446 17.8344 5.15998 17.9054 5.25111 17.9497C5.35463 18 5.48694 18 5.75156 18H19M7.5 21.5H7.51M16.5 21.5H16.51M8 21.5C8 21.7761 7.77614 22 7.5 22C7.22386 22 7 21.7761 7 21.5C7 21.2239 7.22386 21 7.5 21C7.77614 21 8 21.2239 8 21.5ZM17 21.5C17 21.7761 16.7761 22 16.5 22C16.2239 22 16 21.7761 16 21.5C16 21.2239 16.2239 21 16.5 21C16.7761 21 17 21.2239 17 21.5Z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#333",
                      }}
                    >
                      Delivery Details
                    </span>
                  </div>
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#ddbe77",
                      fontWeight: "500",
                    }}
                  >
                    Enter Pincode
                  </span>
                </div>
                {showPincodeInput && (
                  <div
                    style={{ marginTop: "12px", display: "flex", gap: "8px" }}
                  >
                    <input
                      type="text"
                      placeholder="Enter 6-digit pincode"
                      value={pincode}
                      onChange={(e) => setPincode(e.target.value)}
                      maxLength={6}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        fontSize: "14px",
                        outline: "none",
                      }}
                    />
                    <button
                      style={{
                        background: "#ddbe77",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        padding: "8px 16px",
                        fontSize: "13px",
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                    >
                      Check
                    </button>
                  </div>
                )}
              </div> */}

              {/* Order Summary */}
              <div
                style={{
                  background: "#f7f3ff6b",
                  borderRadius: "12px",
                  border: "1px solid #f7f3ff6b",
                  boxShadow: "0 .5px",
                  padding: "16px",
                }}
              >
                {[
                  {
                    label: "Subtotal",
                    value: `₹${Math.trunc(subtotal).toLocaleString("en-IN")}`,
                    valueStyle: {},
                  },
                  otherCharges > 0 && {
                    label: "Stone / Diamond Charges",
                    value: `₹${Math.trunc(otherCharges).toLocaleString("en-IN")}`,
                    valueStyle: {},
                  },
                  {
                    label: "Tax",
                    value: `₹${Math.trunc(taxAmount).toLocaleString("en-IN")}`,
                    valueStyle: { color: "#d1a94d" },
                  },
                ]
                  .filter(Boolean)
                  .map((row, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "6px 0",
                        borderBottom: "1px solid #f5f5f5",
                      }}
                    >
                      <span
                        style={{ fontSize: "13px", color: "var(--ink-900)" }}
                      >
                        {row.label}
                      </span>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "var(--ink-900)",
                          ...row.valueStyle,
                        }}
                      >
                        {row.value}
                      </span>
                    </div>
                  ))}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingTop: "12px",
                    marginTop: "4px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "var(--ink-900)",
                    }}
                  >
                    Total Cost{" "}
                    <small style={{ fontSize: 9, fontWeight: "30" }}>
                      (Incl of all taxes.)
                    </small>
                  </span>
                  <span
                    style={{
                      fontSize: "15px",
                      fontWeight: "700",
                      color: "var(--ink-900)",
                    }}
                  >
                    ₹{Math.trunc(totalCharge).toLocaleString("en-IN")}
                  </span>
                </div>
              </div>

              {/* Validation Warning */}
              {!validation && (
                <div
                  style={{
                    background: "#fff5f5",
                    border: "1px solid #ffc5c5",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    fontSize: "13px",
                    color: "#cc0000",
                  }}
                >
                  ⚠ One item in your cart is Sold. Please remove it to proceed.
                </div>
              )}

              {/* Place Order Button */}
              {validation && (
                <button
                  onClick={checkout}
                  style={{
                    background:
                      "linear-gradient(135deg, #b69a59 0%, #ddbe77 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: "12px",
                    padding: "16px",
                    fontSize: "15px",
                    fontWeight: "700",
                    letterSpacing: "1.5px",
                    cursor: "pointer",
                    width: "100%",
                    transition: "opacity 0.2s",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.opacity = "0.9")}
                  onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
                >
                  PLACE ORDER
                </button>
              )}
            </div>
          </div>
        ) : (
          /* Empty Cart */
          <div style={{ textAlign: "center", padding: "60px 20px" }}>
            <img
              style={{
                width: "180px",
                margin: "0 auto 24px",
                display: "block",
                opacity: 0.6,
              }}
              alt="Empty cart"
              src="data:image/svg+xml;base64,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"
            />
            <h3
              style={{
                fontSize: "20px",
                fontWeight: "700",
                letterSpacing: "1px",
                color: "#b69a59",
                textTransform: "uppercase",
                marginBottom: "16px",
              }}
            >
              Your Cart is Empty
            </h3>
            <button
              onClick={() => history("/ProductList")}
              style={{
                background: "linear-gradient(135deg, #b69a59, #ddbe77)",
                color: "white",
                border: "none",
                borderRadius: "10px",
                padding: "12px 32px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                letterSpacing: "0.5px",
              }}
            >
              Continue Shopping
            </button>
          </div>
        )}
      </div>

      {showModal && (
        <>
          <RemoveCart
            setShowModal={() => setShowModal("")}
            showModal={showModal}
            removeItemFromCart={removeItemFromCart} 
          />
          <div
            style={{
              opacity: 0.4,
              position: "fixed",
              inset: 0,
              zIndex: 40,
              background: "black",
            }}
          />
        </>
      )}
    </>
  );
};